/**
 * cn.js
 *
 * Utility for composing Tailwind CSS class names safely.
 *
 * Combines `clsx` (conditional class logic) with `tailwind-merge`
 * (deduplication of conflicting Tailwind utilities) so that dynamic
 * class strings are always valid and predictable.
 *
 * Usage:
 *   import { cn } from 'utils/cn';
 *   <div className={cn('px-4 py-2', isActive && 'bg-purple-600', className)} />
 */

import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges class names, resolving Tailwind conflicts.
 *
 * @param {...(string|undefined|null|boolean|object)} inputs - Class values accepted by `clsx`
 * @returns {string} A single, deduplicated class string
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}